<template>
    <section id="planes" class="py-16 bg-white">
        <div class="container mx-auto px-4">

            <!-- Overline + Title -->
            <div class="text-center">
                <p class="text-sm font-semibold text-[#84509A]">Precios</p>
                <h2 class="mt-2 text-3xl sm:text-4xl font-extrabold text-slate-900">
                    Precios flexibles para tus necesidades
                </h2>
            </div>

            <!-- SWITCH estilo mifact elevado -->
            <div class="flex justify-center mt-10">
                <div class="flex bg-[#2A275F] rounded-full p-1">

                    <!-- ANUAL -->
                    <button @click="selected = 'anual'"
                        class="px-8 py-2 text-sm font-semibold transition-all rounded-full" :class="selected === 'anual'
                            ? 'bg-[#84509A] text-white shadow-md'
                            : 'text-white/80'">
                        Anual
                    </button>

                    <!-- PARA SIEMPRE -->
                    <button @click="selected = 'para_siempre'"
                        class="px-8 py-2 text-sm font-semibold transition-all rounded-full" :class="selected === 'para_siempre'
                            ? 'bg-[#84509A] text-white shadow-md'
                            : 'text-white/80'">
                        Para siempre
                    </button>

                </div>
            </div>


            <!-- Card dinámico -->
            <article class="mt-12 max-w-lg mx-auto rounded-3xl bg-slate-100 p-8 shadow-sm transition hover:shadow-md">
                <!-- <div class="text-center">
                    <span class="inline-block rounded-full text-white text-xs font-semibold px-3 py-2"
                        :class="selected === 'anual' ? 'bg-[#84509A]' : 'bg-[#14B8A6]'">
                        {{ currentPlan.label }}
                    </span>
                </div> -->

                <!-- Precio -->
                <div class="mt-4 text-center">
                    <div class="text-slate-500 text-sm">{{ currentPlan.subLabel }}</div>

                    <div class="mt-1 flex justify-center items-end gap-2">
                        <span class="text-4xl font-extrabold text-slate-900">
                            {{ currentPlan.price }}
                        </span>
                        <span class="text-slate-500 mb-1 text-sm">
                            {{ currentPlan.period }}
                        </span>
                    </div>
                </div>

                <p class="h-[48px] mt-2 mb-0 text-slate-600 text-center">
                    {{ currentPlan.description }}
                </p>

                <!-- Lista -->
                <ul class="mt-6 space-y-3 text-sm text-slate-700">
                    <li v-for="(item, i) in features" :key="i" class="flex items-center gap-2">
                        <i class="ri-check-line text-green-500 font-bold"></i> {{ item }}
                    </li>

                    <!-- Característica específica del plan -->
                    <li class="flex items-center gap-2">
                        <i class="ri-check-line text-green-500 font-bold"></i>
                        {{ selected === 'anual' ? 'Pago anual' : 'Pago único sin renovaciones' }}
                    </li>
                </ul>

                <!-- Botón -->
                <a :href="currentPlan.whatsapp" target="_blank"
                    class="inline-block text-center mt-8 w-full rounded-xl bg-slate-900 text-white py-3 font-semibold hover:bg-slate-800 transition">
                    Seleccionar plan
                </a>

            </article>

        </div>
    </section>
</template>

<script>
export default {
    name: "PricingPlans",

    data() {
        return {
            selected: "anual",

            plans: {
                anual: {
                    label: "Anual",
                    subLabel: "Pago anual",
                    price: "S/ 180.00",
                    period: "/año",
                    description: "Ahorra pagando anual.",
                    whatsapp:
                        "https://wa.me/51908901200?text=Hola,%20quiero%20información%20sobre%20el%20PLAN%20ANUAL%20de%20Zet"
                },
                para_siempre: {
                    label: "De por vida",
                    subLabel: "Pago único",
                    price: "S/ 800.00",
                    period: "Para siempre",
                    description: "Pago único sin renovaciones.",
                    whatsapp:
                        "https://wa.me/51908901200?text=Hola,%20quiero%20información%20sobre%20el%20PLAN%20DE%20POR%20VIDA%20de%20Zet"
                }
            },

            features: [
                "Libro de reclamaciones digital",
                "URL única personalizable: zet.wize.pe/TUMARCA",
                "Enlace para sitio web",
                "Colores personalizables",
                "Respaldo automático de reclamos",
                "Actualizaciones permanentes",
                "Soporte y documentación"
            ]
        };
    },

    computed: {
        currentPlan() {
            return this.plans[this.selected];
        }
    }
};
</script>